import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteVideo } from "../../../api/endpoints/VideoEndpoints";

export default function useDeleteVideo() {
  return useMutation<void, AxiosError, { videoId: string }>({
    mutationKey: ["delete-video"],
    mutationFn: ({ videoId }) => deleteVideo(videoId),
  });
}
